import { useCallback } from 'react';
import { GeocodedAddressData } from '@/shared/components/AddressAutocomplete';

type UseAddressHandlingProps = {
  userClearedAddressRef: React.MutableRefObject<boolean>;
  setSelectedAddress: (address: string) => void;
  setSelectedLatitude: (lat: number | null) => void;
  setSelectedLongitude: (lng: number | null) => void;
  setSelectedState: (state: string) => void;
  setSelectedCounty: (county: string) => void;
  setSelectedZipCode: (zipCode: string) => void;
};

export const useAddressHandling = ({
  userClearedAddressRef,
  setSelectedAddress,
  setSelectedLatitude,
  setSelectedLongitude,
  setSelectedState,
  setSelectedCounty,
  setSelectedZipCode,
}: UseAddressHandlingProps) => {
  const handleAddressSelectAndGeocode = useCallback(
    (data: GeocodedAddressData) => {
      if (!data.description || data.description.trim() === '') {
        userClearedAddressRef.current = true;
        setSelectedAddress('');
        setSelectedLatitude(null);
        setSelectedLongitude(null);
        setSelectedState('');
        setSelectedCounty('');
        setSelectedZipCode('');
        return;
      }
      userClearedAddressRef.current = false;
      setSelectedAddress(data.description);
      setSelectedLatitude(data.latitude);
      setSelectedLongitude(data.longitude);
      setSelectedState(data.state || '');
      setSelectedCounty(data.county || '');
      setSelectedZipCode(data.zipCode || '');
    },
    [
      userClearedAddressRef,
      setSelectedAddress,
      setSelectedLatitude,
      setSelectedLongitude,
      setSelectedState,
      setSelectedCounty,
      setSelectedZipCode,
    ],
  );

  return { handleAddressSelectAndGeocode };
};

